"use client";

import SearchInput from "./searchInput";
import StorageBreadcrumbs from "./breadcrumbs";
import StorageActions from "./actions";
import StorageTitle from "./title";

export default function StorageHeader() {
    return (
        <header className="flex flex-col lg:flex-row w-full lg:justify-between gap-4">
            <div className="flex w-full flex-col gap-2">
                <StorageTitle />
                <StorageBreadcrumbs />
            </div>

            <div className="flex flex-col sm:flex-row gap-4 sm:gap-2">
                <SearchInput />
                <StorageActions />
            </div>
        </header>
    );
}
